import { InventoryTab } from "../constants";
import { useInventoryContext } from "../contexts/InventoryFilterContext";

const useUniqueVinNumbers = (tab: InventoryTab) => {
	const { filterItems } = useInventoryContext();
	const filteredItems = filterItems?.filter((item) => item.origin !== tab);
	if (filteredItems?.length) {
		return [...new Set(filteredItems?.map((item) => item.vinNumber))];
	}
	return [];
};

export default useUniqueVinNumbers;
